import { FormControl, MenuItem, Select } from '@mui/material';
import { Roles } from 'components/generics/Interface/Api/Response/User/IUser';
import { GridFilterInputValueProps, GridFilterOperator } from '@mui/x-data-grid-pro';

function CustomFilterSelectRightValue(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;

  const handleFilterChange = (event: any) => {
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <FormControl>
      <Select value={item.value ?? 'all'} onChange={handleFilterChange}>
        <MenuItem value="all">Tous</MenuItem>
        <MenuItem value="true">Autorisé</MenuItem>
        <MenuItem value="false">Interdit</MenuItem>
        <MenuItem value="null">Non défini</MenuItem>
      </Select>
    </FormControl>
  );
}

function CustomFilterSelectRole(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;

  const handleFilterChange = (event: any) => {
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <FormControl>
      <Select value={item.value ?? 'all'} onChange={handleFilterChange}>
        <MenuItem value="all">Tous</MenuItem>
        <MenuItem value={Roles.ADMIN}>Admin</MenuItem>
        <MenuItem value={Roles.TECHNICIAN}>Technicien</MenuItem>
        <MenuItem value={Roles.FARMER}>Agriculteur</MenuItem>
      </Select>
    </FormControl>
  );
}

export const functionlityOperators: GridFilterOperator<any, boolean | null>[] = [
  {
    label: 'est égal à',
    value: 'is',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null;
      }
      return (value) => {
        if (filterItem.value === 'true') {
          return value === true;
        }
        if (filterItem.value === 'false') {
          return value === false;
        }
        if (filterItem.value === 'null') {
          return value === null;
        }
        return true;
      };
    },
    InputComponent: CustomFilterSelectRightValue,
  },
];

export const userRoleOperators: GridFilterOperator<any, string>[] = [
  {
    label: 'est égal à',
    value: 'is',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null;
      }
      return (value, row) => {
        if (filterItem.value === 'all') {
          return true;
        }
        return row.role === filterItem.value;
      };
    },
    InputComponent: CustomFilterSelectRole,
  },
];
